import React, { useState } from "react";
import { IonImg, IonLabel } from "@ionic/react";
import "../../global.scss";
import { getImageUrlFromFireStorage } from "../../firebase";

interface SocialIcons {
  imgpath: any;
}

export const CustomIonImage: React.FC<SocialIcons> = ({ imgpath }: SocialIcons) => {
  const [state, setState] = useState("");

  React.useEffect(() => {
    async function getImage() {
      const imagePath = await getImageUrl(imgpath);
      return () => {
        setState("");
      };
    }
    getImage();
  }, []);

  const getImageUrl: any = async (ele: any) => {
    try {
      // console.log("25 =======", ele);
      const imageUrl: any = await getImageUrlFromFireStorage(ele);
      // console.log("IMG URL ===== ", imageUrl);
      setState(imageUrl.metadata);
    } catch (e: any) {
      // alert("No images found");
    }
  };

  return (
    <img
      src={state}
      alt={""}
      style={{
        height: "100%",
      }}
    />
  );
};
